export const SHUFFLE_START_DELAY_MS = 1000;
export const SHARE_COPY_RESET_MS = 3000;
export const HIDDEN_VIDEO_FX_NAMES = ["Pu-241", "Ghost", "Vintage"];

export const SLOWED_VIDEO_FX = {
  value: "slowed",
  name: "Slowed",
  resolution: 1,
  isPro: false,
};

export function ensureSlowedVideoFx(videoFxs) {
  const list = Array.isArray(videoFxs) ? [...videoFxs] : [];
  if (!list.some(({ value }) => value === "slowed")) {
    list.push(SLOWED_VIDEO_FX);
  }
  return list;
}
